import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Zap, Check, ArrowRight } from "lucide-react";

export function StripeConnectPanel() {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get("/owner/stripe/status");
      setStatus(data);
    } catch (err) {
      console.error("Stripe status load failed:", err);
    }
  };

  useEffect(() => {
    load();
    // Refresh once when returning from Stripe onboarding
    if (new URLSearchParams(window.location.search).get("stripe")) {
      setTimeout(load, 800);
    }
  }, []);

  const connect = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/owner/stripe/connect", { origin_url: window.location.origin });
      if (data.connect_disabled) {
        toast.info(data.message, { duration: 8000 });
        return;
      }
      window.location.href = data.onboarding_url;
    } catch (err) {
      toast.error(err.response?.data?.detail || "Cannot start Stripe onboarding");
    } finally {
      setBusy(false);
    }
  };

  if (!status) return null;

  if (status.charges_enabled) {
    return (
      <div data-testid="stripe-connect-panel" className="border hairline p-5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 border border-[#FF3B30] flex items-center justify-center">
            <Check size={16} className="text-[#FF3B30]" />
          </div>
          <div>
            <div className="tick-label text-[#FF3B30]">Payouts active</div>
            <div className="text-neutral-400 text-sm mt-0.5">Bookings pay 85% directly to your Stripe account</div>
          </div>
        </div>
        <span className="tick-label font-mono">{status.account_id?.slice(0, 12)}…</span>
      </div>
    );
  }

  return (
    <div data-testid="stripe-connect-panel" className="border hairline p-6">
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 border hairline flex items-center justify-center">
          <Zap size={20} className="text-[#FF3B30]" />
        </div>
        <div className="flex-1">
          <div className="tick-label">Get paid</div>
          <div className="font-display text-2xl font-bold mt-1">
            {status.connected ? "Finish Stripe onboarding" : "Connect Stripe to receive payouts"}
          </div>
          <p className="text-neutral-400 text-sm mt-2 max-w-lg">
            Cooks pay through the site. When you're connected, 85% of every booking lands in your Stripe account automatically — the 15% platform fee stays with KitchenShare.
          </p>
          <button
            data-testid="stripe-connect-btn"
            onClick={connect}
            disabled={busy}
            className="btn-signal mt-4 inline-flex items-center gap-2 disabled:opacity-50"
          >
            {busy ? "..." : status.connected ? "Continue onboarding" : "Connect Stripe"} <ArrowRight size={14} />
          </button>
        </div>
      </div>
    </div>
  );
}
